//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import foretell from "~/mixins/foretell.js";
import API from "~/api/api";
import aos from "~/mixins/aos.js";

export default {
  layout: "default-no-sticky",
  watch: {},
  mixins: [foretell, aos],
  data() {
    return {
      searchQuery: "",
      UScategories: [
        {
          title: "Business",
          slug: "/categories/business/",
        },
        {
          title: "Business Formation",
          slug: "/categories/business-formation/",
        },

        {
          title: "Business Services",
          slug: "/categories/business-services/",
        },
        {
          title: "Commercial Property",
          slug: "/categories/commercial-property/",
        },
        {
          title: "Estate Planning",
          slug: "/categories/estate-planning/",
        },
        {
          title: "Healthcare",
          slug: "/categories/healthcare/",
        },
        {
          title: "Human Resources",
          slug: "/categories/human-resources/",
        },
        {
          title: "Landlord and Tenant",
          slug: "/categories/landlord-and-tenant/",
        },
        {
          title: "Personal Affairs",
          slug: "/categories/personal-affairs/",
        },
        {
          title: "Property",
          slug: "/categories/property/",
        },
        {
          title: "Marriage and Divorce",
          slug: "/categories/marriage-and-divorce/",
        },
      ],
      USServices: [
        {
          title: "Business Services",
          slug: "/categories/business-services/",
        },
      ],
    };
  },
  methods: {
    searchDocs() {
      return this.docs.filter((doc) => {
        return doc.product
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
      });
    },
    filterDocs(category) {
      if (this.docs) {
        let filteredDocs = this.docs.filter(function(doc) {
          return doc.category === category.title;
        });

        return filteredDocs.sort(function(a, b) {
          var textA = a.product.toUpperCase();
          var textB = b.product.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
      }
    },
  },
  head() {
    if (this.pageInfo && this.metaInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain + "/products";
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },

  mounted() {},
  asyncData({ app, query, params, redirect, error }) {
    return Promise.all([
      API.butterPages.get(app.$axios, "legal-documents", {
        preview: query.preview ? 1 : 0,
      }),
      API.allDocs.getProducts(app.$axios),
    ])
      .then((results) => {
        const pageInfo = results[0];
        const docs = results[1];

        return {
          pageInfo,
          docs,
          loading: false,
          error: false,
        };
      })
      .catch((e) => {
        console.error(e);
        error({ message: "Error fetching data..." });

        return {
          loading: false,
        };
      });
  },
  computed: {
    isFiltered() {
      if (this.$router.currentRoute.path === "/products/services")
        return "services";
      else if (this.$router.currentRoute.path === "/products/documents")
        return "documents";
      return false;
    },
    hero() {
      return this.pageInfo.fields.hero.table;
    },
    platform_new() {
      return this.pageInfo.fields.platform_new.table;
    },
    metaInfo() {
      return this.pageInfo.fields.meta_information.table;
    },
    categories() {
      if (!this.isFiltered) {
        return this.UScategories;
      } else if (this.isFiltered === "documents") {
        return this.UScategories.filter(
          (category) => category.title !== "Business Services"
        );
      } else if (this.isFiltered === "services") {
        return this.USServices;
      }
    },
  },
};
